<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-file"></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>项目信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="handle-box">
                <el-select v-model="query.projectId" filterable placeholder="项目名称" @change="current($event)" value-key="projectId" class="handle-select mr10">
                    <el-option v-for="val in projects" :key="val.id" :value="val.appId" :label="val.cnName"></el-option>
                </el-select>

                <el-input v-model="query.name" placeholder="Filter" @keyup.enter.native="handleSearch" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："文件名"</span>

                <el-select v-model="query.formalOrTest" placeholder="服务器" @change="formalOrTestCurrent($event)" class="handle-select mr10" style="float: right; width: 100px">
                    <el-option
                        v-for="item in formalOrTestData"
                        :key="item.formalOrTestId"
                        :label="item.name"
                        :value="item.formalOrTestId">
                    </el-option>
                </el-select>
            </div>

            <el-table
                :data="table.tableData"
                border
                class="table"
                type="index"
                v-loading="table.loading"
                element-loading-text="正在加载中"
                ref="multipleTable"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{textAlign: 'center'}"
                header-cell-class-name="table-header"
                :default-sort = "{prop: 'createTime', order: 'descending'}"
            >
                <el-table-column fixed prop='name' label='文件名'></el-table-column>
                <el-table-column prop="projectName" label="项目名">
                    <template slot-scope='{row}'>
                        {{computeProfileInfoName(row)}}
                    </template>
                </el-table-column>
                <el-table-column prop='userId' label='发布者'></el-table-column>
                
                <el-table-column label="发布状态" align="center" width="85">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.announceStatus == '0'" type="warning">未发布</el-tag>
                        <el-tag v-if="scope.row.announceStatus == '1'">已发布</el-tag>
                        <el-tag v-if="scope.row.announceStatus == '2'" type="info">已失效</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="发布序号" align="center" width="85">
                    <template slot-scope="scope">
                        <el-tag size='mini' v-if='scope.row.announceStatus !== 0 && scope.row.versionCode'>{{scope.row.versionCode}}</el-tag>
                    </template>
                </el-table-column>
                
                <el-table-column prop="version" label="版本"></el-table-column>
                <el-table-column show-overflow-tooltip prop="description" label="版本描述"></el-table-column>

                <el-table-column prop="createTime" label="上传时间" :formatter="dateFormat" sortable></el-table-column>
                <el-table-column prop="announceTime" label="发布时间" :formatter="dateFormat" sortable></el-table-column>

                <el-table-column label="服务器" >
                    <template slot-scope="{row}">
                        <span v-if="row.isTest == 0">正式</span>
                        <span v-if="row.isTest == 1">测试</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="{row}">
                        <template>
                            <el-button
                            v-if="row.announceStatus === 0"
                            type="text"
                            icon="el-icon-lx-upload"
                            @click="announceFileInfo(row.id, row.announceStatus, row)"
                            >
                                <span>发布项目</span>
                            </el-button>
                            
                            <el-button
                                v-if='row.announceStatus === 2 && row.versionCode !== undefined && row.versionCode > 0 && false'
                                type="text"
                                icon="el-icon-lx-upload"
                                @click="revertVersion(row)"
                            >
                                <span>回退{{row.versionCode}}</span>
                            </el-button>
                        </template>
                        
                        <el-button
                            type="text"
                            icon="el-icon-lx-down"
                            @click="ProjectInfoFileInfo(row.path, row.name)"
                        >下载</el-button>
                        <el-button
                            v-if="row.announceStatus !== 2"
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(row.id, row.path)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="table.pageIndex"
                    :page-size="table.pageSize"
                    :total="table.pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import {
    delFileInfo,
    delFileInfoFormal,
    downloadFile_vue,
    downloadFileFormal_vue,
    findPageVoFileInfo,
    updAnnounceStatus,
    updAnnounceStatusFormal
} from '../../api/projects.js';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { fileAdminApi } from '@api/File/fileInfoAdmin';
import { message } from '@/utils/message';

export default {
    name: 'ProjectInfo',
    data() {
        return {
            query: {
                name: '',       // 搜索框值
                projectId: '',  // 下拉框ID值
                formalOrTest: 0 // 服务器选择 0:正式服 1:测试服
            },

            // 表格数据
            table: {
                tableData: [], // el-table集合
                pageIndex: 1,  // 页码
                pageTotal: 0,  // 总数据量
                pageSize: 0,   // 单页数据量
                loading: true
            },
            
            formalOrTestData: [{ formalOrTestId: 1, name: '测试服' }, { formalOrTestId: 0, name: '正式服' }],  // 正式或测试服务器
            projects: [], // 下拉框集合
            perm: true   // 页面权限
        };
    },
    computed: {
        computeProfileInfoName() {
            return (row) => {
                for (let i = 0; i < this.projects.length; i++) {
                    if (this.projects[i].appId === row.projectId) {
                        return this.projects[i].cnName
                    }
                }
            }
        }
    },
    created() {
        // 下拉框
        this.getProjectName ();
        // 获取表格数据
        this.getData (1, this.query.projectId, this.query.name, this.query.formalOrTest)
        // 刷新角色权限
        this.initRole()
    },
    activated(){
        this.getData (this.table.pageIndex, this.query.projectId, this.query.name, this.query.formalOrTest)
        // 刷新角色权限
        this.initRole()
    },
    methods: {
        //初始化角色权限
        initRole() {
            let role = JSON.stringify(localStorage.getItem('role1'))
            // this.perm = role.indexOf('all') != -1 || role.indexOf('8f0ab88a9f5811ec9b5652540055af6b') != -1 || role.indexOf('98236b649f5811ec9b5652540055af6b') != -1
        },

        //下拉框名称信息
        getProjectName () {
            queryProjectInfoList({pageSize: 10000}).then(res => {
                if (res.code === 200) {
                    this.projects = res.data.result
                }
            })
        },

        //分页获取所有数据
        //pageNum页数，   projectId 下拉框分类，  projectName 搜索框模糊查询
        getData (pageNum, projectId, fileName, formalOrTest) {
            this.table.loading = true

            if (pageNum == undefined) pageNum = 1;
            //验证projectId是否为空
            if (projectId == undefined || projectId == '') projectId = 'NULL'
            //验证projectId是否为空
            if (fileName == undefined || fileName == '')  fileName = 'NULL'
            // 发送请求
            let params = {'pageNum' : pageNum, 'projectId' : projectId, 'fileName' : fileName, 'isTest' : formalOrTest}
            findPageVoFileInfo(params).then(res => {
                if (res.data.code == 200) {
                    this.table.tableData = res.data.data.records;
                    this.table.pageTotal = res.data.data.total;
                    this.table.pageSize = res.data.data.size
                } else {
                    this.$message.error(res.data.message)
                }
                this.table.loading = false
            }).catch (error =>{
                this.table.loading = false
            })
        },

        // 文件发布
        announceFileInfo(id, announceStatus, row) {
            this.$confirm(`将会对已存在项目进行覆盖, 确定要发布么?`, '提示', {
                type: 'warning'
            }).then(() => {
                // announceStatus  0：未发布  1：已发布            isTest  0：正式    1：测试
                let params = {"id": id, 'announceStatus': announceStatus, "isTest": this.query.formalOrTest}
                // 发送请求 - 正式服
                if (this.query.formalOrTest == 0) {
                    let executeStatus = false
                    updAnnounceStatusFormal(params).then(res => {
                        executeStatus = true
                        if (res.data.code == 200) {
                            this.getData (this.table.pageIndex, this.query.projectId, this.query.name, this.query.formalOrTest)
                            this.$message.success(res.data.message)
                        }
                    })
                    setTimeout(() => {
                        if (executeStatus) {
                            return
                        }
                        message.info(`发布请求已发送至服务端, 如果文件比较大, 解压需要点时间, 请勿重复提交`)
                    }, 5000)
                    
                }
                // 发送请求 - 测试服
                if (this.query.formalOrTest == 1) {
                    updAnnounceStatus(params).then(res => {
                        if (res.data.code == 200) {
                            this.getData (this.table.pageIndex, this.query.projectId, this.query.name, this.query.formalOrTest)
                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            })
        },
        revertVersion(row) {
            this.$confirm(`此操作将会导致文件回退至${row.announceTime}时间点, 在该时间后发布的任何新文件及修改都将不存在?`, '提示', {
                type: 'warning'
            }).then(() => {
                fileAdminApi.revertHotUpdateVersion(row.id).then(result => {
                    if (result.code === 200) {
                        this.getData (this.table.pageIndex, this.query.projectId, this.query.name, this.query.formalOrTest)
                        message.success("回退成功")
                    }
                })
            })
        },

        //文件下载
        ProjectInfoFileInfo (path, name) {
            let params = {"path" : path}
            // 正式服
            if (this.query.formalOrTest == 0) {
                downloadFileFormal_vue(params).then(res => {
                    let url = window.URL.createObjectURL(new Blob([res.data]));
                    let link = document.createElement("a");
                    link.style.display = "none";
                    link.href = url;
                    link.setAttribute("download", name); //指定下载后的文件名，防跳转
                    document.body.appendChild(link);
                    link.click();
                }).catch((err) =>{
                    this.$message.error(err.message)
                })
            }
            // 测试服
            if (this.query.formalOrTest == 1) {
                downloadFile_vue(params).then(res => {
                    let url = window.URL.createObjectURL(new Blob([res.data]));
                    let link = document.createElement("a");
                    link.style.display = "none";
                    link.href = url;
                    link.setAttribute("download", name); //指定下载后的文件名，防跳转
                    document.body.appendChild(link);
                    link.click();
                }).catch((err) =>{
                    this.$message.error(err.message)
                })
            }
        },
        
        //下拉框动作
        current(event) {
            this.getData(1, this.query.projectId, this.query.name, this.query.formalOrTest)
        },

        //服务器下拉框
        formalOrTestCurrent() {
            this.getData (1, this.query.projectId, this.query.name, this.query.formalOrTest)
        },

        // 触发搜索按钮
        handleSearch() {
            this.getData (1, this.query.projectId, this.query.name, this.query.formalOrTest)
        },

        // 删除操作
        handleDelete(id) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let params = {"id": id, "isTest": this.query.formalOrTest}
                // 正式服
                if (this.query.formalOrTest == 0){
                    delFileInfoFormal(params).then(res => {
                        if (res.data.code == 200) {
                            setTimeout(() => {
                                this.getData(1, this.query.projectId, this.query.name, this.query.formalOrTest)
                            }, 200);

                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
                // 测试服
                if (this.query.formalOrTest == 1){
                    delFileInfo(params).then(res => {
                        if (res.data.code == 200) {
                            setTimeout(() => {
                                this.getData (1, this.query.projectId, this.query.name, this.query.formalOrTest)
                            }, 200);

                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            })
        },

        // 分页导航
        handlePageChange (val) {
            this.table.pageIndex = val
            this.getData (this.table.pageIndex, this.query.projectId, this.query.name, this.query.formalOrTest)
        },

        // el-tbale 显示时间格式
        dateFormat (row, column) {
            let date = row[column.property]
            if (date == undefined) return ''
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
    }
};
</script>

<style scoped lang="scss">
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
